import { Component, Inject, Input, OnInit } from '@angular/core';
// import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { BlogComponent } from '../blog.component';
import {MatDialog, MatDialogRef ,MAT_DIALOG_DATA} from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface DialogData {
  title: string;
  details: string;
  image:string;
}
@Component({
  selector: 'app-blog-details-modal',
  templateUrl: './blog-details-modal.component.html',
  styleUrls: ['./blog-details-modal.component.scss']
})
export class BlogDetailsModalComponent implements OnInit {
  language: any;
  constructor(private translationService: TranslationService, public modal: NgbActiveModal ) { }
  @Input() data: any;
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
  }
  onNoClick(): void {
     this.modal.close();
  }
}
